'use client'

import { TypographyLongForm } from '../Contentful'
import { useState } from 'react'
import { Button } from 'components/Button'
import { ChevronDown, ChevronUp } from 'react-feather'
import { replaceSpecialKeyVars } from 'utils/shared'

function DataStripContent({ fields }) {
  const variables = fields.variables.fields.jsonContent ?? {}
  const [content] = useState(replaceSpecialKeyVars(fields.content, variables))
  const [source] = useState(replaceSpecialKeyVars(fields.source, variables))
  const [openSource, setOpenSource] = useState(false)
  return (
    <div>
      <TypographyLongForm content={content} />
      {source && (
        <Button
          variant="text"
          onClick={() => setOpenSource(!openSource)}
          endIcon={openSource ? <ChevronUp /> : <ChevronDown />}
          track={{
            ...{
              list_name: 'DATA STRIP SOURCE',
              click_id: openSource ? 'Hide source' : 'Show source',
              click_text: openSource ? 'Hide source' : 'Show source',
              click_type: 'UI Click',
              nav_link_section: 'Data Strip',
              click_position: '0',
              track_event: 'ui_click',
              event_action: 'ui_click',
              event_type: 'ui_click',
            },
          }}
        >
          {openSource ? 'Hide source' : 'Show source'}
        </Button>
      )}
      {openSource && <TypographyLongForm content={source} />}
    </div>
  )
}

export { DataStripContent }
